import BaseObject from "../../base/base_object";
import Event, {SystemEventSubscription} from '../../utils/event';
import _ from '../../utils/underscore';
import DOM from '../../utils/dom';
import Device from '../../utils/device/device';
import ServiceFactory from "../service_factory";
import { SYSTEM_EVENTS } from "../../events/events";
import {IBlueRibbonConnection} from './blue_ribbon_connection_interface';
import {
    IBlueRibbonPartyJackpot,
    PartyJackpotJoinStatus
} from '../../../../common/interfaces/blue-ribbon-party-jackpot.interface';
import {BlueRibbonExecutionMonitor} from './blue_ribbon_helpers';
import {IOrbitComponentInSdk} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service.interface';



export default class PartyJackpotOpenedGameFlowHandler extends BaseObject {
    static CLASS = 'PartyJackpotOpenedGameFlowHandler';

    private _serviceFactory: ServiceFactory;
    private _blueRibbonConnection: IBlueRibbonConnection;
    private _gameType: number = 0;
    private _widgetContainer: HTMLElement;
    private _blueRibbonExecutionMonitor: BlueRibbonExecutionMonitor;
    private _openGameSubscription: SystemEventSubscription = null;
    private _openGameErrorSubscription: SystemEventSubscription = null;
    private _closeGameSubscription: SystemEventSubscription = null;

    init(params) {
        super.init(params);

        if(_.isNullOrUndefined(params.serviceFactory)) {
            this.throwArgumentExpected('34', 'init', 'serviceFactory');
        }

        if(_.isNullOrUndefined(params.blueRibbonConnection)) {
            this.throwArgumentExpected('38', 'init', 'blueRibbonConnection');
        }

        if(_.isNullOrUndefined(params.gameType)) {
            this.throwArgumentExpected('42', 'init', 'gameType');
        }

        this._serviceFactory = params.serviceFactory;
        this._blueRibbonConnection = params.blueRibbonConnection;
        this._gameType = params.gameType;
        this._blueRibbonExecutionMonitor = new BlueRibbonExecutionMonitor(params.serviceFactory);


        this._openGameSubscription = Event.once(SYSTEM_EVENTS.GAME_OPEN, this._onOpenGame, this);
        this._closeGameSubscription = Event.once(SYSTEM_EVENTS.CLOSE_GAME, this._onCloseGame, this);
        this._openGameErrorSubscription = Event.once(SYSTEM_EVENTS.OPEN_GAME_ERROR, this._onOpenGameError, this);


    }

    private _onOpenGameError = () => {
        this._openGameSubscription.off();
        this._closeGameSubscription.off();
    };

    private _startOneFeedPromise: Promise<IBlueRibbonPartyJackpot> = null;
    private _onOpenGame = () => {
        this._blueRibbonExecutionMonitor.info('Game open');
        this._openGameErrorSubscription.off();

        this._startOneFeedPromise = this._serviceFactory.blueRibbonService().getPartyJackpotByGameType(this._gameType)
            .then((partyJackpot) => {
                if(this._isGameClosed) { // It means that the game was closed right after opening so no need to proceed with start one feed.
                    return null;
                }
                if (partyJackpot) {
                    return this._blueRibbonConnection.startOneJackpotFeed(partyJackpot.jackpotId).then(() => {
                        if(partyJackpot.isActive) {
                            this._serviceFactory.blueRibbonService().showPartyJackpotWelcomePopup(partyJackpot).then(status => {
                                if (status === PartyJackpotJoinStatus.Joined) {
                                    this._injectPartyJPWidget(partyJackpot, this._widgetContainer);
                                }
                            });
                        }
                        return partyJackpot;
                    });
                } else {
                    return null;
                }

            });
    }

    private _isGameClosed = false;

    private _onCloseGame = (gameInfo) => {
        this._blueRibbonExecutionMonitor.info('Game closed');
        if(gameInfo.gameType === this._gameType) {
            this._isGameClosed = true;
            const stopOneJackpotFeed = (partyJackpot: IBlueRibbonPartyJackpot) => {
                if(partyJackpot) {
                    return this._blueRibbonConnection.stopOneJackpotFeed(partyJackpot.jackpotId);
                } else {
                    return Promise.resolve();
                }
            }
            this._startOneFeedPromise?.then(stopOneJackpotFeed).catch(stopOneJackpotFeed);
        }

        if(this._inGameWidgetComponent) {
            this._inGameWidgetComponent.unmount();
        }
    }

    setContainer(containerElement: HTMLElement) {
        this._widgetContainer = containerElement;
    }


    private _inGameWidgetComponent: IOrbitComponentInSdk;
    private _injectPartyJPWidget(partyJackpot: IBlueRibbonPartyJackpot, containerDOMElement: HTMLElement) {

        // compute top offset
        let topOffset = 0;
        const gameIFrame = DOM.querySelector(".cgp-game-iframe-container") as HTMLElement;
        if (gameIFrame) {
            const regulationStripeWidth = parseInt(DOM.getCurrentStyle(gameIFrame).top.replace("px", ""));
            if (_.isNumber(regulationStripeWidth)) {
                topOffset = regulationStripeWidth;
            }
        }

        // compute left offset
        let leftOffset = 0;
        if (Device.isMobile()) {
            leftOffset = 105 / 2;
        }

        this._inGameWidgetComponent = this._serviceFactory.orbitComponentRenderService().renderPartyJackpotInGameWidget(containerDOMElement, {
            partyJackpot: partyJackpot,
            boundSelector: '.cgp-game-window-content-body',
            onClick: () => {
                this._serviceFactory.blueRibbonService().showPartyJackpotPromotionPage();
            },
            initialX: leftOffset,
            initialY: topOffset,
        });
    }
}
